export default __webpack_public_path__ + "static/media/aloe_vera.3665d594.jpg";